import { render, staticRenderFns } from "./SharerWaysReport.vue?vue&type=template&id=37b5d7c8"
import script from "./SharerWaysReport.vue?vue&type=script&lang=js"
export * from "./SharerWaysReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports